import { useCallback } from 'react'
import { GetStatusBySlugMethod } from '../_props'
import { patientIdentityStatusSlugsMap } from './_utils'
import { PatientIdentityStatusEnum } from '../../_props'
import { useGetIdsReferencesInsiidentitystatuses } from '@toktokdoctech/tokapi-client'

const useGetPatientInsiIdentityStatus = () => {
    const { data, isLoading, error } = useGetIdsReferencesInsiidentitystatuses()

    const getStatusBySlug: GetStatusBySlugMethod = useCallback(
        (slug: PatientIdentityStatusEnum) => {
            const code = patientIdentityStatusSlugsMap[slug]
            return Promise.resolve(data?.find((status) => status?.code === code))
        },
        [data],
    )

    return {
        getStatusBySlug,
        loading: isLoading,
        error,
    }
}

export default useGetPatientInsiIdentityStatus
